// 组装路由
import Store from '@/store/store'
import Router from '@/router/router'
import { resetRouter } from '@/router/router'
import api from '@/api'
import { NotFoundRoute } from '@/router/routes'
import { getComponent } from '@/router/import'
import { StaticRoutesMap } from '@/router/routes'

/**
 *
 * 递归格式化后端路由为前端路由
 * @param {Array} routes
 * @returns
 */
function formatRoutes(routes) {
    let _routes = [];

    routes.forEach(route => {
        let _route = {
            path: route.path,
            name: route.name,
            menu_parent: route.menu_parent,
            component: getComponent(
                route.name.slice(0, 1).toUpperCase() + route.name.slice(1)
            )
        };

        if (route.children) {
            _route = Object.assign({}, _route, {
                children: formatRoutes(route.children)
            });
        }

        if (route.meta) {
            let obj = {};
            route.meta
                .replace(/\{/g, "")
                .replace(/\}/g, "")
                .split(",")
                .forEach(m => {
                    let data = m
                        .split(":")
                        .map(m => m.replace(/\"|\'/g, "").trim());
                    let k = data[0];
                    let v = data[1];
                    if (k == 'keepAlive') {
                        if (v == 1) {
                            obj["keepAlive"] = true
                        } else {
                            obj["keepAlive"] = false
                        }

                    } else {
                        obj[k] = v;
                    }
                });

            _route = Object.assign({}, _route, {
                meta: obj
            });
        }

        if (route.redirect) {
            _route = Object.assign({}, _route, {
                redirect: route.redirect
            });
        }
        _routes.push(_route);
    });

    return _routes;
}

/**
 * 递归找首页路由路径(即侧边栏第一个的页面)
 * @param {Object} route
 */
function findRedirectPath(route) {
    let foundRoute;
    const find = _route => {
        if (_route.children) {
            find(_route.children.find(r => r.meta['isSidebarItem'] == '1'));
        } else {
            foundRoute = _route;
        }
    };

    find(route);

    return foundRoute;
}

/**
 *
 * 组装所有路由 并挂载完整的路由
 * @export
 * @returns
 */
export function assembleRoutes(callback) {
    // 重置路由
    resetRouter();
    // 先组装静态路由 保证登录页可以使用
    Router.options.routes = [...StaticRoutesMap];
    Router.addRoutes([...StaticRoutesMap]);

    // 如果没有token则不请求路由
    if (Store.getters.token) {
        api.service({
            servername: 'Ruyi_AdminSystemServices',
            method: 'treeData',
            token: Store.getters.token
        }).then(res => {
            if (res.data.data) {
                let requestedRoute = res.data.data;

                // 格式化后端路由
                requestedRoute = formatRoutes([requestedRoute]).pop();
                // 获取侧边栏第一路由作为首页的路径
                let redirectPath = findRedirectPath(requestedRoute).path;

                requestedRoute.redirect = redirectPath;
                // 侧边栏需要用到options里数据
                Router.options.routes.push(requestedRoute);
                // 动态添加格式化后的后端路由)

                // 404页面不能写在静态路由里否则会一直显示404页面
                Router.addRoutes([requestedRoute, NotFoundRoute]);

                Store.commit('SET_HOME_PAGE', redirectPath);
                callback && callback.call(null);
            } else {
                Router.addRoutes([NotFoundRoute]);
            }

        });
    }

}